import styled from "styled-components";

import materialUI from "../../../../../../material-UI";

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.5rem;
  background-color: #fff;
  padding: 24px !important;
  width: 450px;
`;

export const Space: any = styled.div`
  min-height: ${(props: any) => props.space}px;
`;

export const StrongText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
`;

export const StrongText2 = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #000000;
`;

export const LightText = styled.span`
  color: #667085;
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  width: 100%;
`;

export const LightTextGreen = styled.span`
  color: #02de7f;
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const InputLable: any = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props: any) => (props.opacity ? "#d0d0d0" : "#333333")};
  margin-bottom: 8px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const TimePicker = styled(materialUI.TimePicker)`
  width: 100%;
`;

export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  max-height: 40px;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: #c0c0c0 !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
  }
`;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)``;

export const Scroll = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 550px;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Align = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const RowAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
